import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getABlog, getAllBlogs } from "../features/blogs/blogSlice";
import { FaCalendar } from "react-icons/fa";
import moment from "moment";
import BlogBreadCrumb from "../components/BlogBreadcrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import cover from "../images/main-cover2.jpg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import loader from "../images/loader1.jpg"
import { useMediaQuery } from "react-responsive";

const SingleBlog = () => {
  const [loading, setLoading] = useState(true);
  const blogState = useSelector((state) => state?.blog?.singleBlog);
  const allBlogs = useSelector((state) => state?.blog?.blog);
    const isDesktop = useMediaQuery({ minWidth: 768 });
  
  const location = useLocation();
  const getBlogId = location.pathname.split("/")[2];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getABlog(getBlogId)).then(() => setLoading(false));
    dispatch(getAllBlogs());
  }, [dispatch, getBlogId]);

  return (
    <>
      <Meta title={loading ? "Loading..." : blogState?.title} />
       <div>
        {isDesktop ? (
      <BlogBreadCrumb title={loading ? <Skeleton width="50%" /> : blogState?.title}  />

        ) : (
          <></>
        )}
       </div>
      <Container class1="blog-wrapper single-blog-container home-wrapper-2">
        <div className="single-blog-card">
          <div className="single-blog-card-el">
            <div className="single-blog-overlay"></div>
            <div className="single-blog-content">
             <h3 className="title">{blogState?.title}</h3>
              <div className="blog-date">  
              <FaCalendar className="calendar-icon-el" />  
              <span>{moment(blogState?.createdAt).format("MMMM D, YYYY")}</span>  
            </div> 
            </div>
            {loading ? (
              <img src={loader} alt="loader" className="img-loader"/>
            ) : (
              <img
                src={blogState?.images[0]?.url || ""}
                className="img-fluid w-100 mb-3"
                alt="blog"
              />
            )}
          </div>

          <div className="blog-col">
            <div className="blog-content-2-el">
              {loading ? (
                <>
                  <Skeleton width="100%" height="15px" />
                  <Skeleton width="90%" height="15px" />
                  <Skeleton width="95%" height="15px" />
                </>
              ) : (
                blogState?.description && (
                  <p className="blog-paragraph" dangerouslySetInnerHTML={{ __html: blogState.description }} />
                )
              )}
            </div>

            <div className="related-blog-wrapper">
              <div>
                <img src={cover} title="blog" alt="blog" />
              </div>
              <div className="related-blog">
                <h4 className="related-title">Related Posts</h4>
                <div className="blog-hr"></div>
                {loading ? (
                  <>
                    <Skeleton width="80%" height="20px" />
                    <Skeleton width="60%" height="20px" />
                  </>
                ) : (
                  Array.isArray(allBlogs) &&
                  allBlogs
                    .filter((blog) => blog._id !== getBlogId)
                    .slice(0, 2)
                    .map((blog) => (
                      <div key={blog._id} className="related-post">
                        <p className="related-text">{blog.title}</p>
                        <p
                          className="read-more"
                          onClick={() => (window.location.href = `/blog/${blog._id}`)}
                          style={{ cursor: "pointer", textDecoration: "underline" }}
                        >
                          Read More »
                        </p>
                      </div>
                    ))
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SingleBlog;
